function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var _isObjectEmpty = function _isObjectEmpty(obj) {
  // Could probably be simplified to: return Object.keys(obj).length === 0
  for (var prop in obj) {
    if (obj[prop] !== '') return false;
  }

  return true;
};

export var isEmpty = function isEmpty(val) {
  if (val === null || val === undefined) return true;
  return typeof val === 'string' ? !val.trim().length : _typeof(val) === 'object' ? _isObjectEmpty(val) : typeof val === 'boolean' || typeof val === 'number' && val > -1 ? false : true;
};